import React, { useEffect, useRef, useState } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import $ from "jquery";
import "bootstrap-datepicker";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css";
import moment from "moment";
import CreateAdminUi from "./CreateAdminUi";
import Layout from "../../../Components/Layout/Layout";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  useAddAdminMutation,
  useEditAdminMutation,
} from "../../../store/Api/admins";
import { useGetRrbQuery } from "../../../store/Api/common";
import { hidetoast, useDecodeToken } from "../../../Utils/function";
// Define validation schema using Yup



function CreateAdmin() {
  const dispatch = useDispatch();
  // const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation(); // Access state
  const decodedToken = useDecodeToken();
  const { state } = location;
  const id = state?.row?.id;
  const [addAdmin] = useAddAdminMutation();
  const [updateAdmin] = useEditAdminMutation();
  const { data, isFetching, isLoading } = useGetRrbQuery({});
  const rrb = data?.data;
  const toast = useSelector((state) => state.toast);
  const [error, setError] = useState("");

  const validationSchema = Yup.object({
    firstname: Yup.string()
      .trim()
      .required("Please enter your first name")
      .min(2, "First name must be at least 2 characters long"),
    lastname: Yup.string()
      .trim()
      .required("Please enter your last name")
      .min(2, "Last name must be at least 2 characters long"),
    designation: Yup.string()
      .trim()
      .required("Please enter a designation")
      .min(2, "Designation must be at least 2 characters long"),
    phone_number: Yup.string()
      .required("Please enter a phone number")
      .min(10, "Phone number must be exactly 10 digits")
      .max(10, "MPhone number must be exactly 10 digits"),
    role: Yup.string().required("Please select an option").default(""),
  });
  // Auto-hide toast after 3 seconds
  useEffect(() => {
    if (toast.message) {
      hidetoast();
    }
  }, [toast.message, dispatch]);

  const handleSubmit = async (values) => {

    if (
      (parseInt(values?.role) == 1 ||
        (decodedToken?.role != 1 && parseInt(values?.role) == 5)) &&
      values?.rrb_id == ""
    ) {
      setError("Please select an option for RRB");
      return;
    }
    values = { ...values, role: parseInt(values?.role) };
    const trimmedValues = Object.fromEntries(
      Object.entries(values).map(([key, value]) => [
        key,
        typeof value === "string" ? value.trim() : value,
      ])
    );
    try {
      const response = id
        ? await updateAdmin({ id: id, ...trimmedValues })
        : await addAdmin({ ...trimmedValues });
      if (response?.data?.success) {
        navigate("/admins");
      }
    } catch (error) {
      console.log(error, "Admin in error");
    }
  };

  return (
    <Layout>
      <Formik
        initialValues={
          id
            ? {
                firstname: state?.row?.firstname || "",
                lastname: state?.row?.lastname || "",
                designation: state?.row?.designation || "",
                phone_number: state?.row?.phone_number || "",
                role: state?.row?.role || "", // Ensure rolehas a value
                rrb_id: state?.row?.rrb_id || "",
              }
            : {
                firstname: "",
                lastname: "",
                designation: "",
                phone_number: "",
                role: decodedToken?.role == 1 ? "5" : "",
                rrb_id:
                  decodedToken?.role == 1
                    ? decodedToken?.rrb_id.toString()
                    : "",
              }
        }
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formik) => (
          <CreateAdminUi
            formik={formik}
            id={id}
            rrb={rrb?.data}
            toast={toast}
            error={error}
            setError={setError}
            decodedToken={decodedToken}
          />
        )}
      </Formik>
    </Layout>
  );
}

export default CreateAdmin;
